import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";

import { AuthGuard } from "./_guards/auth.guard";
import { StepGuard } from "./_guards/step.guard";
import { LoginComponent } from "./login/login.component";
// import {InicioComponent} from './inicio/inicio.component';
import { CursoComponent } from "./curso/curso.component";
import { DadosPessoaisComponent } from "./dados-pessoais/dados-pessoais.component";
import { EnderecoComponent } from "./endereco/endereco.component";
import { EnsinoMedioComponent } from "./ensino-medio/ensino-medio.component";
import { DocumentoComponent } from "./documento/documento.component";
// import {DocumentosComponent} from './documentos/documentos.component';
// import {HistoricoEscolarComponent} from './historico-escolar/historico-escolar.component';
// import {DiplomaComponent} from './diploma/diploma.component';
// import {DocumentosComplementaresComponent} from './documentos-complementares/documentos-complementares.component';
import { MensagemFinalComponent } from "./mensagem-final/mensagem-final.component";
import { MensagemFinalMatriculaOnlineComponent } from "./mensagem-final-matricula-online/mensagem-final-matricula-online.component";
import { PerguntaDocumentosComponent } from "./pergunta-documentos/pergunta-documentos.component";
import { ProcessoForaPrazoComponent } from "./processo-fora-prazo/processo-fora-prazo.component";
import { PreCadastroComponent } from "./pre-cadastro/pre-cadastro.component";

const APP_ROUTES: Routes = [
  { path: "login", component: LoginComponent },
  {
    path: "pre-cadastro",
    component: PreCadastroComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 1 },
  },
  {
    path: "dados-pessoais",
    component: DadosPessoaisComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 2 },
  },
  // { path: 'inicio', component: InicioComponent, canActivate: [AuthGuard, StepGuard], data: { 'passo': 2 } },
  {
    path: "curso",
    component: CursoComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 3 },
  },
  {
    path: "endereco",
    component: EnderecoComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 4 },
  },
  {
    path: "ensino-medio",
    component: EnsinoMedioComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 5 },
  },
  {
    path: "pergunta-documentos",
    component: PerguntaDocumentosComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 6 },
  },
  {
    path: "documento/:documento",
    component: DocumentoComponent,
    canActivate: [AuthGuard, StepGuard],
    data: { passo: 7 },
  },
  // {path: 'documentos', component: DocumentosComponent, canActivate: [AuthGuard, StepGuard], data: {'passo': 6}},
  // {path: 'diploma', component: DiplomaComponent, canActivate: [AuthGuard, StepGuard], data: {'passo': 7}},
  // {path: 'historico-escolar', component: HistoricoEscolarComponent, canActivate: [AuthGuard, StepGuard], data: {'passo': 8}},
  // {
  //     path: 'documentos-complementares', component: DocumentosComplementaresComponent,
  //     canActivate: [AuthGuard, StepGuard], data: {'passo': 9}
  // },
  {
    path: "mensagem-final",
    component: MensagemFinalComponent,
    canActivate: [AuthGuard, StepGuard],
  },
  {
    path: "mensagem-final-matricula-online",
    component: MensagemFinalMatriculaOnlineComponent,
    canActivate: [AuthGuard, StepGuard],
  },
  { path: "processo-fora-prazo", component: ProcessoForaPrazoComponent },
  { path: ":processo", component: LoginComponent },
  { path: ":processo/:curso", component: LoginComponent },
  { path: ":processo/:curso/:campus", component: LoginComponent },
  { path: ":processo/:curso/:campus/:turno", component: LoginComponent },
  { path: "**", component: LoginComponent },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts